import { UserMinus } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

/** Who an ad set excludes, for ad sets published with exclusions. Nothing for other ad sets. */
const ExclusionNote = ({ note }) => {
    if (!note) return null

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span role="img" aria-label={note} className="tw:shrink-0" data-testid="exclusion-note">
                    <UserMinus size={16} className="tw:text-gray-200" />
                </span>
            </TooltipTrigger>
            <TooltipContent className="tw:max-w-80">
                <span>{note}</span>
            </TooltipContent>
        </Tooltip>
    )
}

export default ExclusionNote
